export enum Directions {
  left = 'left',
  right = 'right',
  top = 'top',
  bottom = 'bottom'
}
